import ErrorApi from "./../utils/ErrorApi"
import JsonFetch from "./../utils/JsonFetch"

if (serverContextPath === null) {
    console.error("Global variable serverContextPath is not defined (is null)!");
}

export default class EaApi {
    static baseUrl =            `${serverContextPath}/api`;
    static ea =                 EaApi.baseUrl + '/ea';

    static staty =              EaApi.ea + '/staty';
    static obce =              EaApi.ea + '/obce';
    static adresy =             EaApi.ea + '/adresy';
    static adresyZtotozni =     EaApi.adresy + '/ztotozni';
    static adresyPopis =        EaApi.adresy + '/popis';

    static getAdresy(fulltext, typyAdres, idObec, max) {
        const uri = EaApi.adresy;
        const data = {
            fulltext,
            typyAdres,
            idObec,
            max
        };
        return ErrorApi.responseResolver(JsonFetch.post(uri, null, data))
    }

    static ztotozniAdresu(adresa) {
        const uri = EaApi.adresyZtotozni;
        return ErrorApi.responseResolver(JsonFetch.post(uri, null, adresa))
    }

    static aktualizujPopis(adresa) {
        const uri = EaApi.adresyPopis;
        return ErrorApi.responseResolver(JsonFetch.post(uri, null, adresa))
    }

    static findStaty() {
        const uri = EaApi.staty;
        return ErrorApi.responseResolver(JsonFetch.get(uri));
    }

    static findObce(fulltext) {
        const uri = EaApi.obce;
        return ErrorApi.responseResolver(JsonFetch.get(uri, {fulltext}));
    }
}
